import React from 'react';
import {IOffer} from "../../../../../../../../app/interfaces/offer/IOffer";
import ForwarderField from "../../../../../../../../components/shared/form/detailsFields/ForwarderField/ForwarderField";

type TransportPlannerProps = {
    offer: IOffer;
};

const OfferTransportPlanner: React.FC<TransportPlannerProps> = ({
                                                       offer
                                                   }) => {
    if (offer.transportPlanner === null) {
        return null;
    }

    return (
        <div className={'details-box-item-field-value'}>
            <ForwarderField user={offer.transportPlanner}
                            chatReplyTo={{
                                type: 'RELEASE',
                                description: offer.chatDescription,
                                id: offer.orderReleaseXid,
                                idExt: null
                            }}/>
        </div>
    );
};

export default OfferTransportPlanner;